import React, { useEffect, useState } from 'react';
import { getApiBase } from '../apiBase';

const API_BASE = getApiBase();

function SchoolBadge() {
  const [hov, setHov] = useState(false);
  const [shine, setShine] = useState(false);
  useEffect(() => { const t = setTimeout(() => setShine(true), 500); return () => clearTimeout(t); }, []);
  return (
    <div className="school-badge" onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ display: 'inline-flex', alignItems: 'center', position: 'relative', overflow: 'hidden', cursor: 'default', padding: '4px 2px' }}>
      {/* Shimmer on mount */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        background: 'linear-gradient(105deg,transparent 35%,rgba(25,96,163,0.1) 50%,transparent 65%)',
        transform: shine ? 'translateX(220%)' : 'translateX(-220%)',
        transition: shine ? 'transform 700ms ease' : 'none'
      }} />
      <span style={{
        fontSize: 18, fontWeight: 600, fontFamily: 'Manrope,sans-serif', color: '#002045',
        textTransform: 'uppercase', position: 'relative', zIndex: 1,
        transform: hov ? 'translateY(-1px)' : 'translateY(0)',
        opacity: hov ? 0.75 : 1,
        transition: 'transform 250ms cubic-bezier(0.4,0,0.2,1), opacity 250ms, letter-spacing 250ms',
        letterSpacing: hov ? '0.28em' : '0.22em',
        textShadow: 'none'
      }}>
        Lord Krishna Public School
      </span>
    </div>
  );
}


export default SchoolBadge;
